import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import { Actions, ofActionDispatched, Select } from '@ngxs/store';
import { SugestionInput } from '@radioking/ui/input';
import amplitude from 'amplitude-js';
import { Observable, Subscription } from 'rxjs';

import { SchedulerCoreState } from '../../../../../../scheduler-core/src/lib/states/scheduler-core.state';
import { ProgramPlaylist } from '../../../models/programs.model';
import {
  ProgramEditPlaylistRequest,
  ProgramEditPlaylistSuccess,
} from '../../../states/programs.actions';

interface DataInput {
  programId: number;
  playlist: ProgramPlaylist;
}

@Component({
  selector: 'rk-program-edit-playlist-modal',
  templateUrl: './program-edit-playlist-modal.component.html',
  styleUrls: ['./program-edit-playlist-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgramEditPlaylistModalComponent implements OnInit, OnDestroy {
  editPlaylistForm: UntypedFormGroup;

  @Select(SchedulerCoreState.allPlaylistsForDropdown)
  playlists$: Observable<SugestionInput[]>;

  playlist: ProgramPlaylist;
  programId: number;

  subscription = new Subscription();

  constructor(
    public readonly dialogRef: MatDialogRef<ProgramEditPlaylistModalComponent>,
    private readonly actions$: Actions,
    @Inject(MAT_DIALOG_DATA) public data: DataInput,
  ) {
    this.playlist = data.playlist;
    this.programId = data.programId;
  }

  ngOnInit(): void {
    const playlistSuggestion: SugestionInput = {
      id: this.playlist.idPlaylist,
      name: this.playlist.playlistName,
      color: this.playlist.color,
      type: this.playlist.type,
    };
    this.editPlaylistForm = new UntypedFormBuilder().group({
      selectedPlaylist: [playlistSuggestion, Validators.required],
      sorting: this.playlist.sorting,
      tracksNumber: [this.playlist.tracksNumber, Validators.required],
    });

    this.subscription.add(
      this.actions$
        .pipe(ofActionDispatched(ProgramEditPlaylistSuccess))
        .subscribe(() => this.dialogRef.close()),
    );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  onCancel() {
    this.dialogRef.close(false);
  }

  @Dispatch()
  submit() {
    amplitude.getInstance().logEvent('edit_playlist_program');
    const formValues = this.editPlaylistForm.value;
    const pPlaylist: ProgramPlaylist = {
      ...this.playlist,
      idPlaylist: formValues.selectedPlaylist.id,
      tracksNumber: formValues.tracksNumber,
      sorting: formValues.sorting,
    };

    return new ProgramEditPlaylistRequest(this.programId, pPlaylist);
  }
}
